module.exports = __webpack_public_path__ + "static/media/noon-now-en.3dac1780.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/noon-now-en.svg
// module id = 852
// module chunks = 2